export const initAnimations = {
    duration: 1400,
    delay: 300,
    easing: "ease-in-out",
    disable: window.innerWidth < 1200,
    once: true
};
